import { useLayoutEffect, useRef, useState, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { consumeNavDirection } from '@/lib/navDirection';

export function AppShell({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const [animClass, setAnimClass] = useState('');
  const prevPathname = useRef(pathname);

  useLayoutEffect(() => {
    if (prevPathname.current === pathname) return;
    prevPathname.current = pathname;
    const dir = consumeNavDirection();
    setAnimClass(dir === 'right' ? 'nav-slide-right' : dir === 'left' ? 'nav-slide-left' : '');
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-neutral-50">
      <Navbar />
      <main className="mx-auto w-full max-w-6xl flex-1 px-8 py-8 pb-28 md:pb-8">
        <div key={pathname} className={animClass}>{children}</div>
      </main>
    </div>
  );
}
